<template>
  <transition name="el-fade-in-linear">

    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1" size="small">
        <el-form-item>
          <el-select v-model="query.brandid" clearable remote filterable placeholder="请选择品牌"
            @change="query.ischange = true">
            <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.hasinventory" filterable clearable @change="query.ischange = true"
            placeholder="是否有库存">
            <el-option v-for="(item, index) in hasinventorylists" :label="item.name" :value="item.id" :key="index" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="query.shippingtempidid" clearable remote filterable placeholder="请选择运费模板"
            @change="query.ischange = true">
            <el-option v-for="(item, index) in shippingtemplists" :key="index" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="query.sorttype" filterable clearable @change="query.ischange = true"
            placeholder="请选择排序类型">
            <el-option v-for="(item, index) in sorttypelists" :label="item.name" :value="item.id" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.sort" filterable clearable @change="query.ischange = true" placeholder="请选择排序方式">
            <el-option v-for="(item, index) in sortlists" :label="item.name" :value="item.id" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.isreplace_grouding" filterable clearable @change="query.ischange = true" placeholder="请选择商品状态">
            <el-option label="上架" value="1" />
            <el-option label="下架" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入商品名称 / 规格名称 / sku" v-model="query.key" clearable @keyup.enter.native="getList"
            @change="query.ischange"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" round @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" size="small" icon="el-icon-plus" round @click="addreplacegoods">新增商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-badge :value="shippingtemps.length > 0 ? shippingtemps.length : ''" class="item">
            <el-button type="warning" icon="el-icon-setting" @click="settingshippingmore">批量设置运费模板</el-button>
          </el-badge>
        </el-form-item>
        <el-form-item>
          <el-button type="" icon="el-icon-delete" @click="clearselectgoods">清除选中商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="" icon="el-icon-sort" @click="showBatchOperation">批量上下架</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="" icon="el-icon-download" @click="downloadExcel">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="" icon="el-icon-upload" @click="dialogVisible = true">导入</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder1" style="margin-top:10px" v-loading="query.loading">
        <div class="goods-special-purcharse">采购次数：{{ statinfo.orders }}</div>
        <div class="goods-special-purcharse">采购数量：{{ statinfo.numbers }}</div>
        <div class="goods-special-purcharse">销售金额：{{ statinfo.sellprices }}</div>
      </div>

      <!-- 商品信息 -->
      <div class="backborder2" style="margin-top:10px;">
        <el-table :data="lists" ref="goodsmultipleTable" v-loading="query.loading" @select="goodsselectchange"
          @select-all="goodsselectall">
          <el-table-column type="selection" width="50" align="center" />
          <el-table-column label="id" width="120" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="goods-special-id">{{ scope.row.id }}</div>
              <div class="goods-special-sku">（sku：{{ scope.row.sku }}）</div>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" align="left" fixed="left" min-width="350">
            <template slot-scope="scope">
              <div class="goods-special-imginfos">
                <div class="goods-special-img">
                  <img :src="scope.row.img != '' ? scope.row.img : require('../../assets/default_img_mini.png')"
                    :style="scope.row.img != '' ? 'max-width:80%;max-height:80%' : 'max-width:80%;max-height:80%'" />
                </div>
                <div :class="scope.row.isgrounding == '0' ? 'goods-special-up' : 'goods-special-down'">
                  {{ scope.row.isgrounding == '0' ? '已上架' : '已下架' }}</div>
              </div>
              <div class="goods-special-content">
                <div class="goods-spicial-name">{{ scope.row.name }}</div>
                <div class="goods-spicial-spec">规格：{{ scope.row.p_spec }}</div>
                <div class="goods-spicial-spec">重量：{{ scope.row.weight }}（kg）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="140" align="center" fixed="left">
            <template slot-scope="scope">
              <div style="float:left;width:100%;text-align:center">
                <span style="font-size:13px">{{ scope.row.brandname }}</span><br />
                <i class="sys-offers-details-brand-grant-no"
                  v-if="scope.row.brandname != '' && scope.row.brandtype == 1">未授权</i>
                <i class="sys-offers-details-brand-grant-yes"
                  v-if="scope.row.brandname != '' && scope.row.brandtype == 2">已授权</i>
                <i class="sys-offers-details-brand-grant-no"
                  v-if="scope.row.brandname != '' && scope.row.brandtype == 3">授权失败</i>
                <i class="sys-offers-details-brand-grant-no"
                  v-if="scope.row.brandname != '' && scope.row.brandtype == 4">授权未开始</i>
                <i class="sys-offers-details-brand-grant-no"
                  v-if="scope.row.brandname != '' && scope.row.brandtype == 5">授权到期</i>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="使用运费模板" width="140" align="center" fixed="left">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.shippingtempmsg" placement="top">
                <span style="float:left;width:100%;text-align:center;font-size:13px">{{ scope.row.shippingtempname
                  }}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="批发价" prop="property_price" width="140" align="center" />
          <el-table-column label="代发价" width="140" align="center">
            <template slot-scope="scope">
              <el-input type="text" size="small" v-model="scope.row.replace_price" @blur="changereplaceprice(scope.row)"
                style="width:70%" />
            </template>
          </el-table-column>

          <el-table-column label="上架" width="120" align="center">
            <template slot-scope="scope">
              <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="scope.row.isreplace_grouding"
                @change="changeGrounding(scope.row)" />
            </template>
          </el-table-column>

          <el-table-column label="库存信息" width="160" align="left">
            <template slot-scope="scope">
              <div class="goods-special-inventorys" v-if="scope.row.type == 0">剩余库存：{{ scope.row.inventorys }}
              </div>
              <div class="goods-special-inventorys" v-if="scope.row.type == 0">
                可用库存：{{ scope.row.lastinventorys }}</div>
            </template>
          </el-table-column>
          <el-table-column label="销售信息" width="160" align="left">
            <template slot-scope="scope">
              <div class="goods-special-inventorys">采购次数：{{ scope.row.orders }}</div>
              <div class="goods-special-inventorys">采购数量：{{ scope.row.numbers }}</div>
              <div class="goods-special-inventorys">销售金额：{{ scope.row.sellprices }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="small" round @click="cannelproperty(scope.row)">撤销</el-button>
              <el-button type="" size="small" round @click="getreplaceselldetails(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="specialpageSizeChange" @current-change="specialpageCurrentChange"
            :current-page="query.p" :page-sizes="[10, 20, 50]" :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="query.rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!-- 获取一件代发商品信息 -->
      <el-dialog title="新增一件代发商品" :visible.sync="addgoodsDialog" width="90%" top="5vh" :before-close="closewindow">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-select v-model="addgoodsquery.brandid" clearable remote filterable placeholder="请选择品牌"
              @change="addgoodsquery.ischange = true">
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入商品名称 / 规格名称 / sku" v-model="addgoodsquery.key" clearable
              @keyup.enter.native="getspecialgoods" @change="addgoodsquery.ischange = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" round @click="getspecialgoods">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" size="small" round @click="savespecialgoods"
              :loading="replaceloading">保存</el-button>
          </el-form-item>
          <el-form-item>
            <template>
              <div class="goods-special-select">已选择商品<i>{{ templists.length }}</i>个</div>
            </template>
          </el-form-item>
        </el-form>

        <div class="goods-special-select-goods">
          <div v-for="(item, index) in templists" :key="index" class="goods-special-select-goods-info">
            <div class="goods-special-select-goods-info-name">{{ item.name }}，</div>
            <div class="goods-special-select-goods-info-price">￥{{ item.price }}</div>
            <div class="goods-special-select-goods-info-click"><a @click="deltemps(item, index)"><img
                  src="../../assets/error.png" /></a></div>
          </div>
        </div>

        <el-table :data="goodslists" ref="replacemultipleTable" v-loading="addgoodsquery.loading"
          @row-click="replaceselectrow" @select="replacehandleSelectsingle" @select-all="replacehandleSelectall">
          <el-table-column type="selection" width="80" />
          <el-table-column label="id" width="135" align="center" fixed="left">
            <template slot-scope="scope">
              <div class="goods-special-id">{{ scope.row.id }}</div>
              <div class="goods-special-sku">（sku：{{ scope.row.sku }}）</div>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" align="left" fixed="left">
            <template slot-scope="scope">
              <div class="goods-special-imginfos">
                <div class="goods-special-img">
                  <img :src="scope.row.img != '' ? scope.row.img : require('../../assets/default_img_mini.png')"
                    :style="scope.row.img != '' ? 'max-width:80%;max-height:80%' : 'max-width:80%;max-height:80%'" />
                </div>
                <div :class="scope.row.isgrounding == '0' ? 'goods-special-up' : 'goods-special-down'">
                  {{ scope.row.isgrounding == '0' ? '已上架' : '已下架' }}</div>
              </div>
              <div class="goods-special-content">
                <div class="goods-spicial-name">{{ scope.row.name }}</div>
                <div class="goods-spicial-spec">规格：{{ scope.row.property_name }}</div>
                <div class="goods-spicial-spec">重量：{{ scope.row.weight }}（kg）</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="品牌" width="120" align="left" fixed="left">
            <template slot-scope="scope">
              <span style="float:left;font-size:13px">{{ scope.row.brandname }}</span><br />
              <i class="sys-offers-details-brand-grant-no"
                v-if="scope.row.brandname != '' && scope.row.brandtype == 1">未授权</i>
              <i class="sys-offers-details-brand-grant-yes"
                v-if="scope.row.brandname != '' && scope.row.brandtype == 2">已授权</i>
              <i class="sys-offers-details-brand-grant-no"
                v-if="scope.row.brandname != '' && scope.row.brandtype == 3">授权失败</i>
              <i class="sys-offers-details-brand-grant-no"
                v-if="scope.row.brandname != '' && scope.row.brandtype == 4">授权未开始</i>
              <i class="sys-offers-details-brand-grant-no"
                v-if="scope.row.brandname != '' && scope.row.brandtype == 5">授权到期</i>
            </template>
          </el-table-column>
          <el-table-column label="批发价" prop="property_price" width="130" align="center" />
          <el-table-column label="代发价" width="130" align="center">
            <template slot-scope="scope">
              <el-input size="small" type="text" v-model="scope.row.replace_price" @focus="stopselect(event)"
                @blur="changespecialprices(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="运费模板" width="150" align="center">
            <template slot-scope="scope">
              <el-select size="small" v-model="scope.row.shipping_tempid" remote filterable placeholder="请选择运费模板"
                @change="selectshippings(scope.row)">
                <el-option v-for="(item, index) in shippingtemplists" :label="item.name" :value="item.id"
                  :key="index" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="剩余库存" width="110" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.type == 0">{{ scope.row.inventorys }}</div>
            </template>
          </el-table-column>
          <el-table-column label="可用库存" width="110" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.type == 0">{{ scope.row.lastinventorys }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="addspecialpageSizeChange" @current-change="addspecialpageCurrentChange"
            :current-page="addgoodsquery.p" :page-sizes="[10, 20, 50]" :page-size="addgoodsquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="addgoodsquery.rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addgoodsDialog = false" style="margin-top:20px">取 消</el-button>
        </div>
      </el-dialog>


      <!-- 批量设置商品运费模板 -->
      <el-dialog title="批量设置商品运费模板" :visible.sync="settingshippingmoreDialog" width="20%" top="15vh">
        <el-select v-model="settingshippingidmore" clearable remote filterable placeholder="请选择运费模板" size="small"
          v-loading="shippingtemploading">
          <el-option v-for="(item, index) in shippingtemplists" :key="index" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
        <el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getshippingtemplists"></el-button>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="settingshippingmoreDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="updategoodsmoreshippingtemplate"
            :loading="settingshippingmoreloading">保 存</el-button>
        </div>
      </el-dialog>

      <!-- 批量上下架 -->
      <el-dialog :visible.sync="showProductShelf" title="批量上下架操作" width="20%">
        <el-select v-model="productShelfType" placeholder="请选择操作" style="width: 100%;">
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="2"></el-option>
        </el-select>

        <span slot="footer" class="dialog-footer">
          <el-button @click="showProductShelf = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
      </el-dialog>


      <!-- 导入数据弹窗 -->
      <el-dialog title="一件代发商品导入" :visible.sync="dialogVisible" width="600px" 
        @closed="failUploadList = [];successUploadCount = 0;fileName = ''">
        <div class="dialog-content">
          <div class="left-column">
            <span>
              <el-button type="primary" size="mini" @click="uploadinfos" :loading="uploadgoodsLoading">上传模板</el-button>
              <span style="margin-left: 20px;">{{ fileName }}</span>
            </span>
            <el-button type="default" size="mini" @click="getdownmoremodel">点击下载模板</el-button>
          </div>
          
        </div>
        <div style="color: red;">注意：单次支持最多500条数据导入</div>
        <div v-if="successUploadCount > 0 || failUploadList.length > 0" class="result-content">导入完成：成功{{ successUploadCount }}条数据，失败{{ failUploadList.length }}条数据。 <el-button type="text" @click="downloadFailedData">下载失败数据</el-button></div>
        
        <!-- slot=footer -->
        <div class="table-upload-footer">
          <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
          <!-- <el-button size="mini" type="primary" @click="dialogVisible = false">确定</el-button> -->
        </div>
      </el-dialog>
      <input id="fileupload" type="file" @change="importFile"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        style="display:none" title="1" />

    </div>
  </transition>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      uploadgoodsLoading: false,
      fileName: '',
      successUploadCount: 0,
      failUploadList: [],
      actionauth: '', //功能权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Goods/index",
      query: {
        act: 'myspeciallists_news',
        isreplace_grouding: '',
        token: this.$cookies.get('token'),
        brandid: '',
        key: '',
        sorttype: '',
        sort: '',
        hasinventory: '',
        shippingtempid: '',
        p: 1,
        rollpage: 10,
        rows: 0,
        loading: false,
        ischange: false,
      },
      lists: [],
      statinfo: {},

      brandquery: {
        act: 'lists',
        token: this.$cookies.get('token'),
        jdshow: 0,
        rollpage: 100000
      },
      brandlists: [],
      hasinventorylists: [{ id: 1, name: '有库存' }, { id: 2, name: '无库存' }],
      sorttypelists: [{ id: 1, name: '按采购次数排序' }, { id: 2, name: '按采购数量排序' }, { id: 3, name: '按销售金额排序' }],
      sortlists: [{ id: 1, name: '倒序' }, { id: 2, name: '升序' }],

      addgoodsDialog: false,
      addgoodsquery: {
        act: 'getreplacegoods',
        token: this.$cookies.get('token'),
        brandid: '',
        key: '',
        rows: 0,
        p: 1,
        rollpage: 10,
        loading: false,
        ischange: false,
      },
      goodslists: [],
      templists: [],
      islockselect: false,
      replaceloading: false,

      shippingtemploading: false,
      shippingtemplists: [],
      shippingtemps: [],
      settingshippingmoreDialog: false,
      settingshippingidmore: '',
      settingshippingmoreloading: false,
      issplitauth: '',
      showProductShelf: false,
      productShelfType: '1'
    }
  },

  mounted() {
    this.getBrand(0);  //获取品牌信息
    this.getList();    //获取商品信息
    this.getshippingtemplists(); //获取运费模板信息

  },

  methods: {
    downloadExcel() {
      const copyQuery = JSON.parse(JSON.stringify(this.query));
      copyQuery.excel = 1

      const url = new URL(this.url);
      Object.keys(copyQuery).forEach(key => url.searchParams.append(key, copyQuery[key]));

      const link = document.createElement('a');
      link.href = url.toString();
      link.download = 'filename.xlsx'; // 设置下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);


      
    },
    // 显示批量上下架
    showBatchOperation() {
      if (this.shippingtemps.length == 0) { this.$message.error("请选择要批量设置的商品"); return false; }
      this.showProductShelf = true;
    },
    // 确认批量上下架
    handleConfirm() {
      const ids = this.shippingtemps.join(',')
      const type = this.productShelfType == '1' ? true : false
      var resource = this.$resource(this.url);
      resource.save({ act: 'changereplace_grouding', token: this.$cookies.get('token'), id: ids, isreplace_grouding: type }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.clearselectgoods()
          this.showProductShelf = false
        }
      }).catch((res) => {

      });

    },
    /** 商品上下架 **/
    changeGrounding(item) {
      var resource = this.$resource(this.url);
      resource.save({ act: 'changereplace_grouding', token: this.$cookies.get('token'), id: item.id, isreplace_grouding: item.isreplace_grouding }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {

        }
      }).catch((res) => {

      });
    },



    /** 清空已选中的商品信息 **/
    clearselectgoods() {
      this.shippingtemps = [];
      this.getList();
    },

    /** 批量保存商品运费模板 **/
    updategoodsmoreshippingtemplate() {
      this.settingshippingmoreloading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'savepropertymoreshippingtemplates', token: this.$cookies.get('token'), templateid: this.settingshippingidmore, ids: this.shippingtemps.join(",") }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.settingshippingmoreloading = false;
        } else {
          this.settingshippingmoreloading = false;
          this.settingshippingmoreDialog = false;
          this.shippingtemps = [];
          this.getList();
        }
      }).catch((res) => {
        this.settingshippingmoreloading = false;
      });
    },

    /** 批量设置运费模板 **/
    settingshippingmore() {
      if (this.shippingtemps.length == 0) { this.$message.error("请选择要批量设置的商品"); return false; }
      this.settingshippingmoreDialog = true;
      this.settingshippingidmore = '';
    },

    ////////////////////////////////////
    /** 勾选商品 **/
    goodsselectchange(val, row) {
      var number = this.shippingtemps.indexOf(row.id);
      number == -1 ? this.shippingtemps.push(row.id) : this.$delete(this.shippingtemps, number);
    },

    /** 全选/全不选商品 **/
    goodsselectall(val, row) {
      var _this = this;
      var number = -1;
      if (val.length > 0) { //新增商品
        val.forEach(function (item, i) {
          number = _this.shippingtemps.indexOf(item.id);
          number == -1 ? _this.shippingtemps.push(item.id) : '';
        });

      } else { //删除商品
        this.lists.forEach(function (item, i) {
          number = _this.shippingtemps.indexOf(item.id);
          number > -1 ? _this.$delete(_this.shippingtemps, number) : '';
        });
      }
    },
    /////////////////////////////////////


    /** 获取运费模板信息 **/
    getshippingtemplists() {
      var resource = this.$resource(this.GLOBAL.domain + "Shippingarea/index");
      resource.save({ act: 'getshippingtemplistsnew', token: this.$cookies.get('token'), temptypelists: 2, sort: 1, p: 1, rollpage: 10000000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.shippingtemploading = false;
        } else {
          this.shippingtemplists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {

      });
    },



    //保存选中的一件代发的商品
    savespecialgoods() {
      if (this.templists.length == 0) { this.$message.error("请选择需要添加的一件代发的商品"); return false; }

      var data = [];
      this.templists.forEach(function (item, index) {
        data.push({ id: item.id, price: item.price, shipping_tempid: item.shipping_tempid });
      });

      this.replaceloading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'savereplacegoods_new', data: JSON.stringify(data), token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.replaceloading = false;
        } else {
          this.replaceloading = false;
          this.addgoodsDialog = false;
          this.getList();
        }
      }).catch((res) => {
        this.replaceloading = false;
      });

    },


    //////////////////////////////////////////////////////////
    //选择一件代发商品信息操作

    //点击单行选择商品
    replaceselectrow(row) {
      if (this.islockselect) return false;

      var number = -1;
      var _this = this;
      this.templists.forEach(function (item, i) {
        if (row.id == item.id) number = i;
      });

      number == -1 ? this.templists.push({ id: row.id, name: row.name, price: row.replace_price, shipping_tempid: row.shipping_tempid }) : this.$delete(this.templists, number);
      this.$refs.replacemultipleTable.toggleRowSelection(row);
    },

    //点击具体行选择商品
    replacehandleSelectsingle(val, row) {
      if (this.islockselect) return false;

      var number = -1;
      var _this = this;
      this.templists.forEach(function (item, i) {
        if (row.id == item.id) number = i;
      });

      number == -1 ? this.templists.push({ id: row.id, name: row.name, price: row.replace_price, shipping_tempid: row.shipping_tempid }) : this.$delete(this.templists, number);
    },

    //全选 / 全不选
    replacehandleSelectall(val) {
      if (this.islockselect) return false;

      var number = -1;
      var propertyids = [];
      var _this = this;

      if (val.length == 0) { //全不选
        this.goodslists.forEach(function (t, i) {
          number = -1;
          _this.templists.forEach(function (tt, ii) {
            if (t.id == tt.id) number = ii;
          });
          number == -1 ? '' : _this.$delete(_this.templists, number);
        });

      } else { //全选
        val.forEach(function (t, i) {
          number = -1;
          _this.templists.forEach(function (tt, ii) {
            if (t.id == tt.id) number = ii;
          });
          number == -1 ? _this.templists.push({ id: t.id, name: t.name, price: t.replace_price, shipping_tempid: t.shipping_tempid }) : '';
        });

      }
    },

    //聚焦输入框，阻止冒泡
    stopselect(event) {
      this.islockselect = true;
      event.preventDefault();
    },

    //修改商品代发价
    changespecialprices(row) {
      var number = -1;
      this.templists.forEach(function (t, i) {
        if (row.id == t.id) number = i;
      });

      number == -1 ? '' : this.templists[number].price = row.replace_price;
      this.islockselect = false;
    },

    //修改选中运费模板
    selectshippings(row) {
      var number = -1;
      this.templists.forEach(function (t, i) {
        if (row.id == t.id) number = i;
      });

      number == -1 ? '' : this.templists[number].shipping_tempid = row.shipping_tempid;
      this.islockselect = false;
    },


    //删除当前选中商品
    deltemps(item, index) {
      var number = -1;
      var _this = this;
      this.goodslists.forEach(function (t, i) {
        if (item.id == t.id) _this.$refs.replacemultipleTable.toggleRowSelection(t);
      });
      this.$delete(this.templists, index);
    },

    //关闭窗口
    closewindow() {
      this.$confirm('您是否放弃当前已选中的商品关闭当前窗口，是否确定 ？', '提示', { type: 'warning' }).then(() => {
        this.addgoodsDialog = false;
      }).catch(() => {

      });
    },

    /////////////////////////////////////////////////////////

    //新增一件代发商品信息
    addreplacegoods() {
      this.addgoodsDialog = true;
      this.addgoodsquery.brandid = '';
      this.addgoodsquery.key = '';
      this.addgoodsquery.p = 1;
      this.addgoodsquery.rollpage = 10;
      this.templists = [];
      this.getspecialgoods();
    },

    //获取新增一件代发商品信息
    getspecialgoods() {
      if (this.addgoodsquery.ischange) {
        this.addgoodsquery.p = 1;
        this.addgoodsquery.rollpage = 10;
      }

      this.addgoodsquery.loading = true;
      var resource = this.$resource(this.url);
      resource.save(this.addgoodsquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.goodslists = JSON.parse(Base64.decode(res.data.Data));
          this.addgoodsquery.rows = parseInt(res.data.count);
          this.addgoodsquery.loading = false;
          if (this.addgoodsquery.ischange) this.addgoodsquery.ischange = false;

          var ids = [];
          var shipping_tempids = [];
          var default_shippingid = '';
          var number = '';
          var _this = this;
          this.templists.forEach(function (t, i) {
            ids.push(t.id);
            shipping_tempids.push(t.shipping_tempid);
          });

          //提取默认运费模板Id
          if (this.shippingtemplists.length > 0) default_shippingid = this.shippingtemplists[0]['id'];
          setTimeout(function () {
            _this.goodslists.forEach(function (t, i) {
              number = ids.indexOf(t.id);
              if (number == -1 && default_shippingid == '') t.shipping_tempid = '';
              if (number == -1 && default_shippingid > 0) t.shipping_tempid = default_shippingid;
              if (number >= 0) t.shipping_tempid = shipping_tempids[number];
            });
            _this.goodslists = JSON.parse(JSON.stringify(_this.goodslists));
            setTimeout(function () {
              _this.goodslists.forEach(function (t, i) {
                number = ids.indexOf(t.id);
                number == -1 ? '' : _this.$refs.replacemultipleTable.toggleRowSelection(t);
              });
            }, 200);
          }, 200);

        }
      }).catch((res) => {

      });
    },

    addspecialpageSizeChange(val) {
      this.addgoodsquery.rollpage = val;
      this.getspecialgoods();
    },
    addspecialpageCurrentChange(val) {
      this.addgoodsquery.p = val;
      this.getspecialgoods();
    },


    //一件代发商品销售详情
    getreplaceselldetails(item) {
      item.propertyid = item.id;
      this.$emit('listenchild', { name: '一件代发商品销售统计', url: 'Mallsalesreplacedetail', data: item });
    },

    //修改商品代发价格
    changereplaceprice(item) {
      if (item.replace_price == '' || Number(item.replace_price) < Number(item.property_price)) {
        this.$confirm('您是否确定设置代发价低于批发价, 是否继续?', '提示', { type: 'warning' }).then(() => {
          var resource = this.$resource(this.url);
          resource.save({ act: 'savereplaceprice', id: item.id, price: item.replace_price, token: this.$cookies.get('token') }).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
            } else {

            }
          }).catch((res) => {

          });
        }).catch(() => {

        });

      } else {
        var resource = this.$resource(this.url);
        resource.save({ act: 'savereplaceprice', id: item.id, price: item.replace_price, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {

          }
        }).catch((res) => {

        });

      }

    },


    /** 撤销一件代发商品 **/
    cannelproperty(item) {
      this.$confirm('您是否确定将该商品从一件代发中撤销, 是否继续?', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.save({ act: 'cannelspecials', id: item.id, status: 0, type: 'replace', token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getList();
          }
        }).catch((res) => {

        });

      }).catch(() => {

      });
    },


    /** 获取列表数据 **/
    getList() {
      if (this.query.ischange) {
        this.query.p = 1;
        this.query.rollpage = 10;
      }

      this.query.loading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.query.loading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.query.rows = parseInt(res.data.count);
          this.lists = result.lists;
          this.statinfo = result.stats;
          this.query.loading = false;
          if (this.query.ischange) this.query.ischange = false;

          var _this = this;
          _this.lists.forEach(function (e, index) {
            e.isreplace_grouding == 1 ? e.isreplace_grouding = false : e.isreplace_grouding = true;
            setTimeout(function () {
              _this.shippingtemps.indexOf(e.id) >= 0 ? _this.$refs.goodsmultipleTable.toggleRowSelection(e) : '';
            }, 200);
          });

        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.query.loading = false;
      });
    },


    specialpageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    specialpageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },


    /** 获取品牌 **/
    getBrand(isshow) {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query(this.brandquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    //重置表单
    reset() {
      this.$refs.create.resetFields();
    },

    //获取功能权限
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    //下载批量导入数据模板
    getdownmoremodel() {
      // location.href = this.GLOBAL.domain + "StorageLocation/download_template?token=" + this.$cookies.get("token");
      location.href = this.GLOBAL.domain + `Inventory/index?token=${this.$cookies.get("token")}&act=down_load_one_stored`
    },
    /** 导入文件 **/
    uploadinfos() {
      document.getElementById("fileupload").click();
    },
    /************** 导入excel表格数据 **************/
    importFile(event) {
      // 通过DOM取文件数据
      var file = event.target.files[0];
      this.fileName = file.name;

      if (!file) return;

      const formData = new FormData();
      formData.append('act', 'upload_stored_goods');
      formData.append('import', file);
      formData.append('token', this.$cookies.get('token'));

      // 清空输入框的文件值，避免下次change事件失效
      document.getElementById('fileupload').value = null;
      this.uploadgoodsLoading = true;

      var resource = this.$resource(this.GLOBAL.domain + 'Inventory/index');
      resource.save(formData).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          if (res.data.Result == 12) {
            this.$message.error(res.data.Message);
          }
          this.uploadgoodsLoading = false;
        } else {
          this.failUploadList = JSON.parse(Base64.decode(res.data.Data));
          this.successUploadCount = res.data.count
          console.log("🚀 ~ importFile ~ this.failUploadList:", this.failUploadList)
          
        }
      }).finally(() => {
        this.uploadgoodsLoading = false;
      })
    },
    // 导出失败数据
    downloadFailedData() {
      if (this.failUploadList.length === 0) {
        this.$message.warning('没有失败数据可导出');
        return;
      }

      // 设置导出表头和字段映射
      const exportHead = [
        '基本条码', 
        '商品编号', 
        '商品名称', 
        '规格', 
        '品牌', 
        '批发价格', 
        '代发价格', 
        '失败原因'
      ];
      
      const exportField = [
        'barcode', 
        'sku', 
        'goods_name', 
        'spec', 
        'band_name', 
        'wholesale_price', 
        'proxy_price', 
        'err_msg'
      ];

      // 动态加载Export2Excel模块
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../vendor/Export2Excel');
        
        // 直接使用failUploadList作为数据源
        const data = this.formatJson(exportField, this.failUploadList);
        
        // 导出Excel文件
        export_json_to_excel(exportHead, data, '导入失败数据');
      });
    },

    // 格式化JSON数据 (这个方法应该已经在您的代码中存在)
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }

  }
}
</script>

<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.goods-special-id {
  color: #666666;
  font-size: 13px;
  display: inline-block;
  width: 100%
}

.goods-special-sku {
  color: #999999;
  font-size: 12px;
  display: inline-block;
  width: 100%
}

.goods-special-imginfos {
  display: inline-block;
  width: 62px;
  height: 62px;
  font-size: 0;
}

.goods-special-img {
  float: left;
  width: 60px;
  height: 60px;
  background: rgba(221, 221, 221, .3);
  border: 1px solid rgba(221, 221, 221, .7);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.goods-special-img img {
  border-radius: 6px
}

.goods-special-up,
.goods-special-down {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 12px;
  line-height: 12px;
  color: #fff;
  padding: 3px 10px;
  border-radius: 15px;
  margin: 5px 0 0 -10px;
}

.goods-special-up {
  background: #67C23A;
}

.goods-special-down {
  background: #909399;
}

.goods-special-content {
  display: inline-block;
  width: calc(100% - 60px - 12px);
  height: 60px;
  margin-left: 5px;
}

.goods-spicial-name {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 23px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-spicial-spec {
  float: left;
  width: 100%;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sys-offers-details-brand-grant-no {
  font-size: 12px;
  color: #fff;
  background: #909399;
  line-height: 12px;
  padding: 3px 0;
  border-radius: 15px;
  font-style: normal;
  text-align: center;
  margin-top: 5px;
  padding: 3px 10px
}

.sys-offers-details-brand-grant-yes {
  font-size: 12px;
  color: #fff;
  background: #67C23A;
  line-height: 12px;
  padding: 3px 0;
  border-radius: 15px;
  font-style: normal;
  text-align: center;
  margin-top: 5px;
  padding: 3px 10px
}

.goods-special-inventorys {
  display: inline-block;
  width: 100%;
  font-size: 13px
}

.goods-special-purcharse {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  margin-right: 3%;
  color: red;
  padding: 0 0 15px 0
}

.goods-special-select {
  font-size: 13px;
  color: red;
}

.goods-special-select i {
  font-style: normal;
  font-size: 14px;
  font-weight: 550;
  padding: 0 10px;
}

.goods-special-select-goods {
  display: inline-block;
  border-radius: 6px;
  margin: 10px 0;
  width: calc(100% - 20px);
  padding: 10px;
  background: rgba(221, 221, 221, .3);
  border: 1px solid rgba(221, 221, 221, .7);
  font-size: 0;
}

.goods-special-select-goods-info {
  float: left;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  background: #f56c6c;
  border-radius: 15px;
  margin: 5px 10px 5px 0;
}

.goods-special-select-goods-info-id,
.goods-special-select-goods-info-name,
.goods-special-select-goods-info-price {
  line-height: 13px;
  line-height: 23px;
  float: left;
}

.goods-special-select-goods-info-click {
  float: left;
  margin: 3px 0 0 10px;
}

.goods-special-select-goods-info-click a {
  float: left;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-left: 5%;
  background: #fff;
}

.goods-special-select-goods-info-click img {
  float: left;
  width: 100%
}

.dialog-content {
  display: flex;
  justify-content: space-between;
}

.left-column {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.right-column {
  display: flex;
}

.table-upload-footer {
  margin-top: 20px;
  text-align: right;
}
.result-content {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/mall/Goodsspecial.vue